import { IApplicationContext } from '../../ApplicationContext';
import { infoAreaBicTable, ApplicableTableSettings } from "../../tableSettings";
import { TextAlignLeftRenderer, TextRenderer, DateRenderer } from '../../uiControls/SmartTableRenderers';
import SmartTable from '../../uiControls/SmartTable';
import { openNewPage, NavigationType } from '../../util/navigationHelpers';
import {AcctDetail} from '../../fms.core/AcctDetail';
import { IJobListViewContext } from "./JobListViewContext";
import CurrencyLabel from "../../uiControls/CurrencyLabel";
import Label from '../../ui/Label';
import LinkButton from '../../ui/LinkButton';
import { getJobNameFromInvBillCrDbJobType, isHouseJob, isMasterJob } from '../../framework.core/JobNames';

interface infoareaBicParam {
  appContext:IApplicationContext, 
  jobName:string, 
  jobId:number, 
  jobListContext:IJobListViewContext,
  infoHeadline: string|undefined,
  history:any
}
async function loadInfoAreaInvoiceBillCrDb({appContext, jobName, jobId, jobListContext, history, infoHeadline = undefined }:infoareaBicParam) {
  const apiResult = await appContext.api.getJobAcctDetails(jobName, jobId);

  if (!apiResult) {
    return null;
  }

  function AccountingEntityRenderer(onLinkToAccounting:any, {data, row, value}:any) {
    const entity = data[row.index];
  
    return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
      <LinkButton onClick={() => onLinkToAccounting(entity)}>{value}</LinkButton>
    </div>;
  }
  
  function onLinkToAccounting(entity:AcctDetail) {
    if (!entity || !entity.type || !entity.invoiceNo) {
      return;
    }
  
    if (entity.type === 'B') {
      const linkPath = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(entity.jobType)}/${entity.jobId}/${entity.id}`
      openNewPage(history, linkPath, NavigationType.newPage);
    }
    if (entity.type === 'I') {
      const linkPath = `/accounting/invoice/view/${getJobNameFromInvBillCrDbJobType(entity.jobType)}/${entity.jobId}/${entity.id}`
      openNewPage(history, linkPath, NavigationType.newPage);
    }
    if (entity.type === 'C') {
      const linkPath = `/accounting/crdb/view/${getJobNameFromInvBillCrDbJobType(entity.jobType)}/${entity.jobId}/${entity.id}`
      openNewPage(history, linkPath, NavigationType.newPage);
    }
  }
  
  function CurrencyRenderer(value:number|null|undefined, currency:string, isLast:boolean=false) {
    return (
      <div style={{height: '100%', width: '100%'}}>
        <div style={{paddingTop: '5px', lineHeight: '12px', paddingRight: '5px', textAlign: 'right', width: '100%'}}>
          <CurrencyLabel currency={currency} value={value} />
        </div>
      </div>
    );
  }
  
  function acctTypeRenderer({value}:any) {
    if(value === 'I') return <div className="ifms-table-default">Invoice</div>;
    else if(value === 'B') return <div className="ifms-table-default">Bill</div>;
    else if(value === 'C') return <div className="ifms-table-default">CrDb</div>;
    else return <span></span>;
  }

  function jobTypeRenderer({value}:any) {
    let job = getJobNameFromInvBillCrDbJobType(value);
    if(isMasterJob(job)) return <div className="ifms-table-default">M</div>;
    else if(isHouseJob(job)) return <div className="ifms-table-default">H</div>;
    else return <span></span>;
  }

  const tableOptions:ApplicableTableSettings = {
    tableName: 'infoAreaBicTable',
    ...infoAreaBicTable,
    data: apiResult,
    
    rowRenderers: [
      { accessor: 'postDate', Cell: DateRenderer },
      { accessor: 'type', Cell: acctTypeRenderer },
      { accessor: 'jobType', Cell: jobTypeRenderer },
      // @ts-ignore:next-line
      { accessor: 'invoiceNo', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting) },
      { accessor: 'entityName', Cell: TextAlignLeftRenderer },
      { accessor: 'cur', Cell: TextRenderer },
      // @ts-ignore:next-line
      { accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur) },
      // @ts-ignore:next-line
      { accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur) },
      // @ts-ignore:next-line
      { accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true) },
    ],
  };

  return (
    <div style={{width: '1240px', marginLeft: 'auto', marginRight: 'auto'}}>
      <div style={{marginTop: '10px', paddingLeft: '10px'}}>
        <Label label={infoHeadline} bold />
      </div>
      <SmartTable {...tableOptions} />
    </div>
  );
}

export default loadInfoAreaInvoiceBillCrDb;
